import { Subscription } from 'rxjs';
import { SHCompareLadderComponent } from './s-h-ladder/s-h-compare-ladder.component';
import { AppConfig } from './../app.config';
import { CompareExplainComponent } from './../explain/compare-explain.component';
import { SHLadderSelection } from './s-h-ladder/s-h-ladder-selection';
import { SurvivalHorizonData } from '@liquitics/transaction';
import { DetailComponent } from './../detail/detail.component';
import { BucketingStrategy } from './../bucket/bucketing-strategy';
import { SHLadderComponent } from './s-h-ladder/s-h-ladder.component';
import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DashboardEventService } from '../dashboard/dashboard-event.service';

@Component({
    selector: 'app-survival-horizon',
    templateUrl: './survival-horizon.component.html',
    styleUrls: ['./survival-horizon.component.scss']
})
export class SurvivalHorizonComponent implements OnInit, OnDestroy {
    mode = 'live';
    currencies: string[] = [];
    currency: string;

    profileType: string;
    shLadderFXFlex: string;
    showMarketData: boolean;
    showSHChart: boolean;
    loroNostroFXFlex: string;
    projectionFXFlex: string;

    // @ViewChild(SHLadderComponent, {static: true}) survivalHorizonLadderComponent: SHLadderComponent;
    @ViewChild(SHCompareLadderComponent, { static: true }) compareLadderComponent: SHCompareLadderComponent;
    @ViewChild(CompareExplainComponent, { static: true }) compareExplainComponent: CompareExplainComponent;

    subscription: Subscription;

    constructor(private dashboardEventService: DashboardEventService,
        private appConfig: AppConfig,
        private changeDetectorRef: ChangeDetectorRef) {
        this.profileType = this.appConfig.activeUserProfile.getProfileType();
    }

    ngOnInit() {
        this.subscription = this.dashboardEventService.survivalHorizonModeSubject.subscribe({
            next: mode => {
                this.mode = mode;
                this.profileType = this.appConfig.activeUserProfile.getProfileType();
                this.initForCurrencies();
            }
        });
        this.subscription.add(this.dashboardEventService.compareLadderRowSelectionSubject.subscribe({
            next: selection => {
                if (this.compareExplainComponent) {
                    this.compareExplainComponent.explain(selection.selectedCurrency, selection.currencyIndex, selection.data.bucketStart);
                }
            }
        }));
        this.subscription = this.dashboardEventService.ladderViewModeSubject.subscribe({
            next: mode => {
                this.showSHChart = (mode === 'chart');
                this.updateFlexSettings();
            }
        });
        this.initForCurrencies();
    }

    ngOnDestroy() {
        this.changeDetectorRef.detach();
        this.subscription.unsubscribe();
    }

    private initForCurrencies() {
        this.currencies = this.appConfig.activeUserProfile.getCurrencies();
        this.currency = this.currencies[0];
        this.updateFlexSettings();
    }

    private updateFlexSettings() {
        this.showMarketData = (this.profileType === 'TWO_CURRENCY');
        const shLadderPercentage = 20 * this.currencies.length;
        this.shLadderFXFlex = '0 0 ' + shLadderPercentage + '%';
        if (this.showSHChart) {
            this.shLadderFXFlex = '0 0 40';
        }

        this.loroNostroFXFlex = '0 0 60%';
        this.projectionFXFlex = (this.profileType === 'TWO_CURRENCY') ?
            '0 1 60%' : '0 1 40%';
    }

    onCurrencySelected(event) {
        this.currency = event.value;
        this.compareLadderComponent.currency = event.value;
        this.mode = 'none';
        this.changeDetectorRef.detectChanges();
        this.mode = 'compare';
        this.changeDetectorRef.detectChanges();
    }
}
